export enum PreloadWarmUpStatus {
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'failed',
}

export enum PreloadMessageSource {
  Host = 'checkout-preload-host',
  Viewer = 'checkout-preload-viewer',
}

export enum PreloadMessageType {
  LoadCart = 'loadCart',
  Ready = 'ready',
  WarmUpLoadFailed = 'warmUpLoadFailed',
  CartLoadFailed = 'cartLoadFailed',
  Navigate = 'navigate',
}

export enum NavigationTarget {
  ThankYouPage = 'thankYouPage',
  Cart = 'cart',
  Home = 'home',
  ExternalUrl = 'externalUrl',
}

export type LoadCartMessage = {
  source: PreloadMessageSource.Host;
  type: PreloadMessageType.LoadCart;
  payload: {cartId?: string};
};

export type NavigationPayload =
  | {reason: NavigationTarget.Home}
  | {reason: NavigationTarget.Cart}
  | {reason: NavigationTarget.ExternalUrl; url: string; inNewTab: boolean}
  | {reason: NavigationTarget.ThankYouPage; data: {orderId?: string}};

export type LinkNavigationTarget = NavigationTarget.Home | NavigationTarget.Cart;

export type NavigationMessage = {
  source: PreloadMessageSource.Viewer;
  type: PreloadMessageType.Navigate;
  payload: NavigationPayload;
};

export type PendingNavigationRequest = {
  requestId: number;
  message: NavigationMessage;
};
